import { UserService } from '../../core/user/user.service';
import { BaseComponent } from '../base.component';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CoachDetailsService } from '../../entities/slot/coach-details.service';
import { CoachReasoning } from '../../core/user/coach-reasoning.model';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { TranslateService } from "@ngx-translate/core";
import * as i0 from "@angular/core";
import * as i1 from "ngx-webstorage";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../core/user/user.service";
import * as i4 from "../../entities/slot/coach-details.service";
import * as i5 from "../../ng-jhipster/language";
import * as i6 from "@ngx-translate/core";
import * as i7 from "@angular/common";
import * as i8 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i9 from "../upload-image-component/profile-image.component";
import * as i10 from "../badge/badge.component";
import * as i11 from "../../entities/session/schedule-session/supported-languages/supported-languages.component";
import * as i12 from "@fortawesome/angular-fontawesome";
function CoachBioComponent_div_0_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "badge-component", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("coachDetails", ctx_r8.coachDetails);
} }
function CoachBioComponent_div_0_div_1_supported_languages_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "supported-languages", 22);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("list", ctx_r9.coachLanguages);
} }
const _c0 = function () { return ["en"]; };
function CoachBioComponent_div_0_div_1_supported_languages_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "supported-languages", 22);
} if (rf & 2) {
    i0.ɵɵproperty("list", i0.ɵɵpureFunction0(1, _c0));
} }
const _c1 = function () { return []; };
function CoachBioComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelement(2, "profile-image", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "h4", 15);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CoachBioComponent_div_0_div_1_div_7_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 16);
    i0.ɵɵelementStart(9, "ngb-rating", 17);
    i0.ɵɵlistener("rateChange", function CoachBioComponent_div_0_div_1_Template_ngb_rating_rateChange_9_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.score = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 18);
    i0.ɵɵelementStart(11, "u", 19);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵtemplate(15, CoachBioComponent_div_0_div_1_supported_languages_15_Template, 1, 1, "supported-languages", 20);
    i0.ɵɵtemplate(16, CoachBioComponent_div_0_div_1_supported_languages_16_Template, 1, 2, "supported-languages", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵstyleProp("flex-direction", ctx_r3.isScreenMd ? "row" : "column");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("coachId", ctx_r3.coach.id)("coachLogin", ctx_r3.coach.login)("videoEnabled", ctx_r3.coachDetails.videoChatEnabled)("size", 90);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r3.coach.login);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.coachDetails);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("rate", ctx_r3.score)("starTemplate", _r1)("readonly", true);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(13, 14, ctx_r3.score, "1.0-1"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3.coachLanguages != null && ctx_r3.coachLanguages != i0.ɵɵpureFunction0(17, _c1));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.coachLanguages === null || ctx_r3.coachLanguages === undefined || ctx_r3.coachLanguages === i0.ɵɵpureFunction0(18, _c1));
} }
function CoachBioComponent_div_0_div_8__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 26);
    i0.ɵɵelement(1, "use", 27);
    i0.ɵɵelementEnd();
} }
function CoachBioComponent_div_0_div_8__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 26);
    i0.ɵɵelement(1, "use", 28);
    i0.ɵɵelementEnd();
} }
function CoachBioComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function CoachBioComponent_div_0_div_8_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.switchToButton("myExperience"); });
    i0.ɵɵtemplate(1, CoachBioComponent_div_0_div_8__svg_svg_1_Template, 2, 0, "svg", 24);
    i0.ɵɵtemplate(2, CoachBioComponent_div_0_div_8__svg_svg_2_Template, 2, 0, "svg", 24);
    i0.ɵɵelement(3, "span", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r4.getButtonColor("myExperience"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedButton === "myExperience");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.selectedButton !== "myExperience");
} }
function CoachBioComponent_div_0_div_9__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 26);
    i0.ɵɵelement(1, "use", 31);
    i0.ɵɵelementEnd();
} }
function CoachBioComponent_div_0_div_9__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 26);
    i0.ɵɵelement(1, "use", 32);
    i0.ɵɵelementEnd();
} }
function CoachBioComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("click", function CoachBioComponent_div_0_div_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.switchToButton("education"); });
    i0.ɵɵtemplate(1, CoachBioComponent_div_0_div_9__svg_svg_1_Template, 2, 0, "svg", 24);
    i0.ɵɵtemplate(2, CoachBioComponent_div_0_div_9__svg_svg_2_Template, 2, 0, "svg", 24);
    i0.ɵɵelement(3, "span", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r5.getButtonColor("education"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedButton === "education");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.selectedButton !== "education");
} }
function CoachBioComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p", 33);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "h4", 34);
    i0.ɵɵelementStart(4, "p", 33);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r6.selectedCoachReasoning.experiences);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r6.selectedCoachReasoning.iceBreakers);
} }
function CoachBioComponent_div_0_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "li", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 37);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const e_r22 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(e_r22.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(e_r22.school + " " + e_r22.year);
} }
function CoachBioComponent_div_0_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, CoachBioComponent_div_0_div_11_div_2_Template, 5, 2, "div", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r7.selectedCoachReasoning.educations);
} }
function CoachBioComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CoachBioComponent_div_0_div_1_Template, 17, 19, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelement(3, "h4", 5);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6);
    i0.ɵɵtemplate(8, CoachBioComponent_div_0_div_8_Template, 4, 3, "div", 7);
    i0.ɵɵtemplate(9, CoachBioComponent_div_0_div_9_Template, 4, 3, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, CoachBioComponent_div_0_div_10_Template, 6, 2, "div", 9);
    i0.ɵɵtemplate(11, CoachBioComponent_div_0_div_11_Template, 3, 1, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.coach != null && ctx_r0.coachDetails != null);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.selectedCoachReasoning.coachReasoningText);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCoachReasoning.experiences != null && ctx_r0.selectedCoachReasoning.experiences.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCoachReasoning.educations != null && ctx_r0.selectedCoachReasoning.educations.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCoachReasoning.experiences != null && ctx_r0.selectedCoachReasoning.experiences.length > 0 && ctx_r0.selectedButton === "myExperience");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.selectedCoachReasoning.educations != null && ctx_r0.selectedCoachReasoning.educations.length > 0 && ctx_r0.selectedButton === "education");
} }
const _c2 = function () { return ["fas", "star"]; };
const _c3 = function () { return ["far", "star"]; };
function CoachBioComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 38);
    i0.ɵɵelementStart(1, "span", 39);
    i0.ɵɵelementStart(2, "em", 40);
    i0.ɵɵelement(3, "fa-icon", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "em", 42);
    i0.ɵɵelement(5, "fa-icon", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const fill_r23 = ctx.fill;
    i0.ɵɵclassProp("full", fill_r23 === 100);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("width", fill_r23, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(6, _c2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(7, _c3));
} }
export class CoachBioComponent extends BaseComponent {
    constructor(sessionStorage, modalService, userService, coachDetailsService, languageService, translateService) {
        super(sessionStorage, modalService);
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.userService = userService;
        this.coachDetailsService = coachDetailsService;
        this.languageService = languageService;
        this.translateService = translateService;
        this.selectedButton = 'myExperience';
    }
    ngOnInit() {
        console.log(this.coach);
        this.score = this.coach.coachScore || this.coach.coachScorec;
        this.selectedLanguage = this.languageService.getCurrentLanguage();
        this.coachDetailsService.findCoachDetails(this.coach.id).subscribe(coachDetails => {
            this.coachDetails = coachDetails.body;
        });
        this.userService.getAllCoachReasoningsByCoachId([this.coach.id]).subscribe(coachReasoningList => {
            this.coachReasoningList = coachReasoningList.body;
            if (this.selectedCoachReasoning === null || this.selectedCoachReasoning === undefined)
                this.selectedCoachReasoning = this.getCoachReasoning();
        });
        this.userService.getCoachReasoningLanguages(this.coach.id).subscribe((coachLanguages) => {
            this.coachLanguages = coachLanguages || [];
        });
        this.translateService.onLangChange.subscribe(() => {
            this.selectedLanguage = this.languageService.getCurrentLanguage();
            this.selectedCoachReasoning = this.getCoachReasoning();
        });
    }
    getCoachReasoning() {
        return this.coachReasoningList.find(cr => cr.lang === this.selectedLanguage);
    }
    getButtonColor(tab) {
        let result;
        if (this.selectedButton === tab)
            result = 'tab-selected';
        else
            result = 'tab-deselected';
        return result;
    }
    switchToButton(tab) {
        this.selectedButton = tab;
    }
}
CoachBioComponent.ɵfac = function CoachBioComponent_Factory(t) { return new (t || CoachBioComponent)(i0.ɵɵdirectiveInject(i1.SessionStorageService), i0.ɵɵdirectiveInject(i2.NgbModal), i0.ɵɵdirectiveInject(i3.UserService), i0.ɵɵdirectiveInject(i4.CoachDetailsService), i0.ɵɵdirectiveInject(i5.JhiLanguageService), i0.ɵɵdirectiveInject(i6.TranslateService)); };
CoachBioComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoachBioComponent, selectors: [["coach-bio"]], inputs: { coach: "coach", selectedCoachReasoning: "selectedCoachReasoning" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["class", "olha-theme bg-white coach-info-card", 4, "ngIf"], ["t", ""], [1, "olha-theme", "bg-white", "coach-info-card"], ["class", "d-flex justify-content-start align-items-start", 3, "flex-direction", 4, "ngIf"], [1, "coach-text-div"], ["jhiTranslate", "settings.headers.Why do I coach", 1, "mb-2"], [1, "p-0", "mb-4", "d-flex", "justify-content-start", "align-items-center"], ["class", "tab-selection", 3, "ngClass", "click", 4, "ngIf"], ["class", "tab-selection m-2", 3, "ngClass", "click", 4, "ngIf"], [4, "ngIf"], [1, "d-flex", "justify-content-start", "align-items-start"], [1, "coach-image-div"], [3, "coachId", "coachLogin", "videoEnabled", "size"], [1, "coach-name-div"], [1, "d-flex", "justify-content-start", "align-items-center", "coach-header-div"], [2, "margin", "0!important", "margin-right", "15px !important"], [1, "mb-2"], ["max", "5", 3, "rate", "starTemplate", "readonly", "rateChange"], [1, "px-2"], [2, "text-decoration", "none"], [3, "list", 4, "ngIf"], [3, "coachDetails"], [3, "list"], [1, "tab-selection", 3, "ngClass", "click"], ["style", "height: 16px; width: 16px; margin-right: 4px;", 4, "ngIf"], ["jhiTranslate", "settings.headers.myExperience"], [2, "height", "16px", "width", "16px", "margin-right", "4px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#folder-44A38B"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#folder-7CBFAE"], [1, "tab-selection", "m-2", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.education"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#grad-cap-44A38B"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#grad-cap-7CBFAE"], [1, "my-experience-text"], ["jhiTranslate", "settings.headers.You should know about me", 1, "mb-2"], [4, "ngFor", "ngForOf"], [1, "education-title"], [1, "education-school-year"], [1, "star"], [1, "half"], [2, "color", "#44A38D"], [3, "icon"], [1, "cursor", 2, "color", "#44A38D"]], template: function CoachBioComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CoachBioComponent_div_0_Template, 12, 6, "div", 0);
        i0.ɵɵtemplate(1, CoachBioComponent_ng_template_1_Template, 6, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.selectedCoachReasoning != null);
    } }, directives: [i7.NgIf, i8.JhiTranslateDirective, i9.ProfileImageComponent, i2.NgbRating, i10.BadgeComponent, i11.SupportedLanguagesComponent, i7.NgClass, i7.NgForOf, i12.FaIconComponent], pipes: [i7.DecimalPipe], styles: [".coach-info-card[_ngcontent-%COMP%]{border-radius:20px;max-height:500px;overflow:scroll}.coach-header-div[_ngcontent-%COMP%]{color:var(--text-dark-green, #0A4A3A);font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:600;line-height:130%}.coach-name-div[_ngcontent-%COMP%]{padding:10px}.coach-image-div[_ngcontent-%COMP%], .coach-text-div[_ngcontent-%COMP%]{padding:10px 10px 10px 0}.star[_ngcontent-%COMP%]{position:relative;display:inline-block;font-size:1rem}.half[_ngcontent-%COMP%]{position:absolute;display:inline-block;overflow:hidden}.badge[_ngcontent-%COMP%]{background:rgba(68,163,141,.1);color:#44a38b;border-radius:16px;padding:1px 20px;width:120px;height:30px;margin:10px}.tab-selection[_ngcontent-%COMP%]{text-decoration:underline;font-family:Poppins,serif;font-size:14px;font-style:normal;font-weight:700;line-height:100%;cursor:pointer}.tab-selected[_ngcontent-%COMP%]{-webkit-text-decoration-color:#44a38b;text-decoration-color:#44a38b;color:#44a38b}.tab-deselected[_ngcontent-%COMP%]{-webkit-text-decoration-color:#7cbfae;text-decoration-color:#7cbfae;color:#7cbfae}.my-experience-text[_ngcontent-%COMP%]{color:var(--text-dark-green, #0A4A3A);font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%}.education-title[_ngcontent-%COMP%]{color:#0a4a3a;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:700;line-height:140%}.education-school-year[_ngcontent-%COMP%]{color:#0a4a3a;font-family:Open Sans,serif;font-size:14px;font-style:normal;font-weight:400;line-height:140%}"] });
